import { createSystem, defaultConfig } from '@chakra-ui/react';

export const v3System = createSystem(defaultConfig);
